<template>
  <v-select
    class="chat-recipients"
    multiple
    label="name"
    :input-id="inputId"
    :value="value"
    :options="options"
    :filterable="false"
    :selectable="(u) => !excluded(u)"
    :placeholder="placeholder"
    @search="onSearch"
    @input="$emit('input', $event)"
  >
    <template #option="u">
      <div class="d-flex align-items-center" style="gap: 8px">
        <span class="chat-avatar">{{ initials(u.name) }}</span>
        <div style="min-width: 0">
          <div class="font-weight-bold text-truncate">{{ u.name }}</div>
          <small class="text-muted text-truncate d-block">{{ subtitle(u) }}</small>
        </div>
      </div>
    </template>
    <template #selected-option="u">{{ u.name }}</template>
    <template #no-options="{ search }">
      <span v-if="!search || search.length < 2">Type at least 2 letters of a name</span>
      <span v-else-if="loading">Searching…</span>
      <span v-else>No one found you can message</span>
    </template>
  </v-select>
</template>

<script>
import api from "../api";
import { initials } from "../format";

const TYPE_NAMES = {
  shis: "Agency",
  employee: "Agency staff",
  provider: "Facility",
  provider_employee: "Facility staff",
  tpa: "HMO",
  tpa_employee: "HMO staff",
};

// Multi-select of people this user may message (the API applies agency and role rules).
export default {
  name: "RecipientPicker",
  props: {
    value: { type: Array, default: () => [] }, // user summaries
    excludeIds: { type: Array, default: () => [] },
    placeholder: { type: String, default: "Search by name…" },
    inputId: { type: String, default: undefined },
  },
  data() {
    return { options: [], loading: false, timer: null };
  },
  methods: {
    initials,
    excluded(u) {
      return this.excludeIds.map(Number).includes(Number(u.id));
    },
    subtitle(u) {
      return [u.job_title || TYPE_NAMES[u.type], u.organisation].filter(Boolean).join(" · ");
    },
    onSearch(search) {
      clearTimeout(this.timer);
      if (!search || search.trim().length < 2) {
        this.options = [];
        return;
      }
      this.loading = true;
      this.timer = setTimeout(() => {
        api
          .searchUsers(search.trim())
          .then((users) => {
            this.options = users;
          })
          .catch(() => {
            this.options = [];
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
  },
};
</script>

<style scoped>
.chat-avatar {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #eef2ff;
  color: #1e40af;
  font-size: 0.72rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
